// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"AvatarUploader_avatarWrapper__Vp03c","round":"AvatarUploader_round__TEG4U","userAvatar":"AvatarUploader_userAvatar__MWcSm"};